module.exports = __webpack_public_path__ + "img/ico_course_test.7486e43d.png";